const LAST_NUMBER = /(\d+)(\D*)$/;

/**
 * Suggests the label after `label`: its last number goes up by one and keeps its zero padding
 * (QA-PL-001 → QA-PL-002, v9 → v10); a label without a number gets a "-2" suffix.
 */
export const nextPricelistVersionLabel = (label: string) => {
  const match = LAST_NUMBER.exec(label);
  if (!match) {
    return `${label}-2`;
  }
  const [, digits, rest] = match;
  const next = (BigInt(digits) + BigInt(1)).toString().padStart(digits.length, '0');
  return `${label.slice(0, match.index)}${next}${rest}`;
};
